import React from "react";
import { BannerWithMobile } from "@ecologi/react-components/src/BannerWithMobile";
import { useStore } from "../../store";

export default function BannerWithMobileWidget(props) {
  const { user } = useStore();
  return <BannerWithMobile {...props.data} user={user} />;
}
